export const THERAPEUTIC_PRODUCT_CLASS_OPTIONS = [
    { value: "DISPOSITIF_MEDICAL", label: "Dispositif médical" },
    { value: "COMPLEMENT_NUTRITIONNEL", label: "Complément nutritionnel" },
];

export const THERAPEUTIC_FILTER_CLASS_OPTIONS = [
    { value: "", label: "Toutes les classes" },
    { value: "MEDICAMENT", label: "Médicaments" },
    ...THERAPEUTIC_PRODUCT_CLASS_OPTIONS.map(option => ({ ...option, label: `${option.label}s` })),
];

export function firstProductCode(codes) {
    return String(codes || "").split(";").map(code => code.trim()).find(Boolean) || "";
}
